import React from 'react';
import PopupSendMail from '../agents-incomes-table/PopupSendMail';

export function SendSMSColumnFormatter(cellContent) {
  return (
    <PopupSendMail
      invoiceTypeID={cellContent.type}
      invoiceNum = {cellContent.num}
    />
  )
}
